export function isDemoEntryPath(url: string): boolean {
  return /^\/demo\/[^/]+\/?$/.test(url.split(/[?#]/)[0]);
}
